/**
 * FAQ Accordion Module
 * Handles accordion expand/collapse with accessibility
 */

import { trackFAQExpand } from './gtm-events.js';

export function initFaqAccordion() {
  const accordions = document.querySelectorAll('.faq-section__accordion');

  accordions.forEach(accordion => {
    const toggles = accordion.querySelectorAll('[data-accordion-toggle]');

    toggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        const item = toggle.closest('.accordion-item');
        const content = item.querySelector('.accordion-item__content');
        const icon = item.querySelector('.accordion-item__icon');
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

        // Close all other items in this accordion
        accordion.querySelectorAll('.accordion-item--open').forEach(openItem => {
          if (openItem !== item) {
            openItem.classList.remove('accordion-item--open');
            const openToggle = openItem.querySelector('[data-accordion-toggle]');
            const openContent = openItem.querySelector('.accordion-item__content');
            const openIcon = openItem.querySelector('.accordion-item__icon');

            openToggle?.setAttribute('aria-expanded', 'false');
            openContent?.setAttribute('hidden', '');
            if (openIcon) {
              openIcon.innerHTML = '<svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>';
            }
          }
        });

        // Toggle current item
        if (isExpanded) {
          item.classList.remove('accordion-item--open');
          toggle.setAttribute('aria-expanded', 'false');
          content?.setAttribute('hidden', '');
          if (icon) {
            icon.innerHTML = '<svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>';
          }
        } else {
          item.classList.add('accordion-item--open');
          toggle.setAttribute('aria-expanded', 'true');
          content?.removeAttribute('hidden');
          if (icon) {
            icon.innerHTML = '<svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor"><path d="M19 13H5v-2h14v2z"/></svg>';
          }

          // Track FAQ expand in GTM
          // Support both Pro page (.accordion-item__title) and Care page (.accordion-item__question) selectors
          const questionText = toggle.querySelector('.accordion-item__question, .accordion-item__title')?.textContent?.trim() || 'Unknown';
          trackFAQExpand(questionText);
        }
      });
    });
  });
}
